<template>	
	<div>
			<div class="mfty-box">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Lark-MES企业制造执行系统
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row" style="justify-content: space-between;">
						<img src="../../assets/img/cpzxImg1.png" />
						<div class="col" style="margin-left: 25px;justify-content: flex-start;">
							<div class="item-no" style="font-size: 24px;color: #000;">
								什么是Lark-MES系统？
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;margin-top: 20px;line-height: 25px;text-align: left;">
								Lark-MES系统即制造执行系统，是上海贸宝信息技术有限公司自主研发，构建于中国自有知识产权的基础业务平台之上，符合MESA/ISA-S95标准，基于批次过程控制，以及企业建模技术，是企业内部物流、生产体系、品质部门的保障系统，为企业实现JIT拉动模式、Lean精益生产、6Sigma-TQM全面质量管理、为企业迈进“工业4.0/中国制造2025” 打下坚实的基础。MES制造执行系统能够有效地优化企业的生产管理模式，强化过程管理和控制，为企业生产创造巨大的价值：
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 直接提升制造执行力、交付能力;
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 让生产以及物流环节透明、透明、更透明；
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 尽可能地对生产过程追根溯源，满足合规要求；
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 及时、准时、实时地把握变化，随需应变。
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<div class="mfty-box" style="background-color: #f3f3f3;height: 700px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					车间管理常见问题
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row">
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon1.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								生产现场管理混乱
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								造成资源和物料的浪费
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon2.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								生产进度不透明
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								给业务和跟单带来诸多不便
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon3.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								产品不良率不了解
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								质量控制难度大
							</div>
						</div>
					</div>
					<div class="row" style="margin-top: 60px;">
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon4.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								仓库管理不规范
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								造成材料积压过多
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon5.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								生产排程不合理
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								造成订单延误和漏单经常发生
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/cpzxIcon6.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								物料查找麻烦
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								造成人力资源成本上升
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="mfty-box" style="height: 750px;position: relative;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Lark-MES系统核心功能
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div class="row ju-c al-c" style="position: absolute;top: 400px;">
					<div class="item ju-c">
						<img src="../../assets/img/leftArrow.png" @click="changeIndex" />
					</div>
					<div class="item-no" style="width: 1100px;"></div>
					<div class="item ju-c">
						<img src="../../assets/img/rightArrow.png"  @click="changeIndex"/>
					</div>
				</div>
				<div v-if="pageIndex==0" style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div style="background-color: #fff;width: 70px;top: 220px;left: 565px;height: 70px;border-radius: 50%;position: absolute;"></div>
					<div class="row" style="justify-content: space-between;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #0bcdcd;padding: 40px 50px;">
							 <div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								 设备管理
							 </div>
							 <div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
							 	解决问题：设备状态不明确，经常故障停机，保养维护管理滞后等,MES系统提供设备台帐、设备维修，产线主动呼叫维修、设备保养、点检计划等全方位的管理，并对设备的运行性能进行分析，使设备处于良好的状态。
							 </div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #20d29f;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								绩效管理
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：统计人员有效工作时间。人员在各工位通过登录系统并记录产出数量(可依据实际情况选择人工录入或自动获取)，并由系统自动统计出每日总产量、产出良率等。从而实现为绩效考核和生产计划制定提供数据基础的目的。
							</div>
						</div>
					</div>
					<div class="row" style="justify-content: space-between;margin-top: 30px;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #ff9852;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								可视化追溯
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：漏工序、生产进度难以管控、生产瓶颈问题难以发现。MES系统帮助惬意建立正反向全流程追溯体系，包含生产设备、生产人员、生产批次、生产开始时间、结束时间、生产时的工业参数等信息，记录产品在整个生产过程中的生产数据。
							</div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #6f7af5;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								报表看板
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：实时掌控生产及物流信息、作业指导书集中管理实时更新等。报表看板在MES系统中占有举足轻重的作用，MES系统获取到的生产信息通过报表展示出来，让生产状况及相关的信息透明化，对生产状况了如指掌。
							</div>
						</div>
					</div>
				</div>
				<div v-if="pageIndex==1" style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div style="background-color: #fff;width: 70px;top: 220px;left: 565px;height: 70px;border-radius: 50%;position: absolute;"></div>
					<div class="row" style="justify-content: space-between;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #0bcdcd;padding: 40px 50px;">
							 <div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								 计划管理
							 </div>
							 <div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
							 	解决问题：资源约束，均衡生产，快速反应，优化排产，降低库存，减少成本。MES系统通过对接ERP系统，获取生产计划，制定对应的生产工单，并通过对生产状况信息的获取，反馈给生产计划，并根据实际的生产情况做出相应的调整。
							 </div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #20d29f;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								供应商管理
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：供应商物料到哪了？物料缺料导致的生产等待，影响生产排产等。MES系统支持物料在途可视化信息查看，准确了解供应商及时状况，提高排产准确度，避免由于物料缺料导致的生产等待，提高交期。
							</div>
						</div>
					</div>
					<div class="row" style="justify-content: space-between;margin-top: 30px;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #ff9852;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								仓库管理
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：物料先进先出，收发物料效率低下，人力、物料、存放场地混乱与浪费等。MES系统提供在库信息及时统计，物料自动定位，JIT式拉料等方法，有效避免呆滞料造成的物料浪费及仓库储存位置占用，减少仓库备料时间，提高生产效率。
							</div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #6f7af5;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								品质管理
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：如何控制(QC)预防出错，异常处理，如何计划，如何改正?MES系统支持SPC质量数据实时计算，提供品质异常报警，批号锁定、设备锁定等功能，提供动态的品质数据监控，有效避免批量性产品问题产生。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				curHeight: 0,
				pageIndex:0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			changeIndex(){
				if(this.pageIndex==0){
					this.pageIndex=1
				}else{
					this.pageIndex=0
				}
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>


	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
</style>
